import { ValueMixerLayer } from '@api/fileManagerApi';
import { SIM_SUN4D, SIM_VVA } from '@visualizer/types';
import { Frame } from 'Simulations/Frame';

export const formatFrameLabel = (index: number | undefined, framesInfo: any, isAggregate?: boolean) => {
    if (index == undefined) return 0;
    const { names, max, simKind } = framesInfo;
    let frameName = names[index];
    if (!frameName) return;
    if (max == 12) {
        if (simKind === SIM_SUN4D) return frameName.slice(0, 3);
        else if (simKind === SIM_VVA && frameName == 'Default') return 'All';
        else return frameName;
    } else if (simKind === SIM_SUN4D && max == 24) {
        if (frameName.length == 1) frameName = '0' + frameName;
        if (isAggregate) return frameName;
        let nextFrame = index < names.length - 1 ? names[index + 1] : '00';
        if (nextFrame.length == 1) nextFrame = '0' + nextFrame;
        return `${frameName}-${nextFrame}`;
    } else return frameName;
};

export const convertFrame = (frame: Frame): ValueMixerLayer[] => {
    const sensors = frame.getSensors();
    const rawScalars = frame.getRawScalarValues();
    const rawVectors = frame.getRawVectorialValues();

    // Getting the value from the raw scalars, avoids issues with possibly wrong frame ranges:
    return sensors.map((s, index) => {
        return {
            id: s.getID(),
            value: rawScalars[index],
            direction: rawVectors[index],
        };
    });
};
